import React, { useState, useEffect } from 'react';
import * as _ from 'lodash';

// utilities
import { messageUtility } from '../utilities/messageUtility';
import { DIRECT_REDIRECT_LINK } from '../utilities/constants';
import { useFetchDataWithToken } from '../utilities/useFetchData';
import urlParamManager from '../utilities/urlParamManager';

//modals
import { Information } from '../components/modals/common';

// service
import SessionStorageService from '../services/utilities/SessionStorageService';
import DirectApiSettingsApi from '../services/DirectApiSettings';

// components
import { ConferencePageHeader } from '../components/PageHeader';
import DirectRegisterOrganizationExecModal from '../components/externalService/DirectRegisterOrganizationExecModal';

// icon
import { SuccessCheckCircleIcon } from '../components/icons/SuccessCheckCircleIcon';
import { FailedCircleIcon } from '../components/icons/FailedCircleIcon';

/**
 * Direct連携情報登録
 *
 * @export
 * @class DirectApiSettingRedirect
 * @extends {React.Component}
 */
function DirectApiSettingRedirect(props) {
  const [isShowRedirectSuccessModal, setIsShowRedirectSuccessModal] = useState(
    true
  );
  const [
    isShowRegisterOrganizationExecModal,
    setIsShowRegisterOrganizationExecModal,
  ] = useState(false);

  const directOauthInfo = JSON.parse(
    SessionStorageService.getDirectOauthInfo()
  );
  const code = _.get(directOauthInfo, 'code', null);
  const state = _.get(directOauthInfo, 'state', null);
  const error = _.get(directOauthInfo, 'error', null);
  const linkKey = _.get(directOauthInfo, 'linkKey', '');
  const loginId = _.get(directOauthInfo, 'loginId', '');
  const redirectUrl = `${DIRECT_REDIRECT_LINK}/${linkKey}/${loginId}`;
  const fieldId = SessionStorageService.getFieldId();
  const isFetchStart = !_.isNull(code) && !_.isNull(state) && _.isNull(error);

  const { isInitLoded, isError } = useFetchDataWithToken(
    DirectApiSettingsApi.authentication_register.exec_options(fieldId, {
      redirect_url: redirectUrl,
      code,
      state,
    }),
    DirectApiSettingsApi.authentication_register.exec_default_response(),
    false,
    true,
    isFetchStart
  );

  const isRedirectSuccess = isFetchStart && isInitLoded && !isError;
  const isRedirectError = !isFetchStart || isError;

  const onClose = () => {
    urlParamManager.setPage('ExternalServiceCooperation', props.vw);
    urlParamManager.publish();
  };

  useEffect(() => {
    return () => {
      // このページを離れた時に、direct認証情報は利用不可とする(必要なら最初から操作させる)
      SessionStorageService.removeDirectOauthInfo();
    };
  }, []);

  // BLDE_V2-49064対応：URLがリダイレクトページ以外の時は、ページをリロードする。
  if (!window.location.toString().includes('DirectApiSettingRedirect')) {
    window.location.reload();
  }

  return (
    <React.Fragment>
      <div className='slide-view show'>
        <div className='slide-view__view'>
          <ConferencePageHeader
            loaded='true'
            title='direct 連携中'
            onClose={onClose}
          />
          <div className='slide-view__body'>
            direct連携中です…
            <br />
            しばらく待っても遷移しない場合は
            <a onClick={onClose}>こちら</a>
            を押してください。
          </div>
        </div>
      </div>
      {isRedirectSuccess && (
        <React.Fragment>
          <DirectRedirectSuccessModal
            visible={isShowRedirectSuccessModal}
            onClose={() => {
              setIsShowRedirectSuccessModal(false);
              setIsShowRegisterOrganizationExecModal(true);
            }}
          />
          <DirectRegisterOrganizationExecModal
            visible={isShowRegisterOrganizationExecModal}
            setVisible={setIsShowRegisterOrganizationExecModal}
            onClose={onClose}
          />
        </React.Fragment>
      )}
      {isRedirectError && (
        // onCloseで画面遷移するので、state管理不要
        <DirectRedirectErrorModal visible={true} onClose={onClose} />
      )}
    </React.Fragment>
  );
}

function DirectRedirectErrorModal({ visible, onClose }) {
  return (
    <React.Fragment>
      <Information
        visible={visible}
        onClose={onClose}
        title={
          <React.Fragment>
            <FailedCircleIcon />
            {messageUtility.getMessage('E-001-447')}
          </React.Fragment>
        }
        message={messageUtility.getMessage('E-001-448')}
        buttonText={messageUtility.getMessage('I-000-017')}
        rootClassName={'DirectDescriptionModal--RedirectError'}
      />
    </React.Fragment>
  );
}

function DirectRedirectSuccessModal({ visible, onClose }) {
  return (
    <React.Fragment>
      <Information
        visible={visible}
        onClose={onClose}
        title={
          <React.Fragment>
            <SuccessCheckCircleIcon />
            {messageUtility.getMessage('I-001-550')}
          </React.Fragment>
        }
        message={messageUtility.getMessage('I-001-551')}
        buttonText={messageUtility.getMessage('I-000-248')}
        rootClassName={'DirectDescriptionModal--RedirectSuccess'}
      />
    </React.Fragment>
  );
}

export { DirectApiSettingRedirect };



// WEBPACK FOOTER //
// ./src/pages/DirectApiSettingRedirect.jsx